export default {
    methods: {
        numeral(value, format) {
            return numeral(value).format(format);
        },

        currency(amount) {
            return numeral(amount).format("$0,0.00");
        }
    }
};
